<template>
  <div id="app">
    <template v-if="$route.meta.alive">
      <Header v-if="!isEastView"></Header>
      <TopNavBar v-else></TopNavBar>
    </template>
    <div class="container">
      <router-view />
    </div>
    <template v-if="$route.meta.isFooter">
      <Footer v-if="!isEastView"></Footer>
      <!-- <EastViewFooter v-else></EastViewFooter> -->
    </template>
    <template v-if="$route.meta.isScrollTop">
      <el-backtop :right="30" :bottom="68" :visibility-height="50"></el-backtop>
    </template>
    <!-- AI 智能对话浮窗 -->
    <AiChatFloat v-if="false"></AiChatFloat>
    <AntiCrawlerChallenge />
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Footer from './components/Footer/Footer.vue'
import EastViewFooter from './components/Footer/EastViewFooter.vue'
import TopNavBar from './components/Header/TopNavBar.vue'
import AiChatFloat from './components/AiChatFloat/AiChatFloat.vue'
import { isEastView } from '@/assets/js/config'
import AntiCrawlerChallenge from "./components/AntiCrawlerChallenge.vue";
export default {
  components: { Header, Footer, EastViewFooter, TopNavBar, AiChatFloat, AntiCrawlerChallenge },
  name: 'APP',
  data() {
    return {
      aiEnabled: process.env.VUE_APP_AI_ENABLED === 'true',
      isEastView
    }
  }
}
</script>

<style lang="scss">

#app {
  min-width: $minWidth;
  overflow-x: hidden; /* 兜底：允许 full-bleed 通栏元素（如首页 100vw banner）不触发横向滚动条 */
  .container {
    @include flex-style(center, center);
    background-color: #ffffff;
  }
}
</style>
